export const shouldShowMrtImplantDocumentNotice = (serviceTypeExternalId, questionId) => {
  const mrtServiceTypeId = process.env.REACT_APP_MRT_SERVICE_TYPE_EXT_ID;
  const noticeQuestionId = process.env.REACT_APP_MRT_IMPLANT_DOCUMENT_QUESTION_ID;

  return Boolean(
    mrtServiceTypeId &&
      noticeQuestionId &&
      String(serviceTypeExternalId) === mrtServiceTypeId &&
      String(questionId) === noticeQuestionId,
  );
};
